// import './App.css';
// import Home from './pages/Home';
// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
// import Login from "./pages/Login";
// import Admin from "./pages/AdminDashboard";
// import User from "./pages/UserDashboard";
// import ProtectedRoute from "./components/ProtectedRoute";
// import Register from "./pages/Register";
// import ForgotPassword from "./pages/ForgotPassword";
// import ResetPassword from "./pages/ResetPassword";
// import Header from "./components/Header";

// function App() {

//   const userRole = sessionStorage.getItem("role");

//   return (
//     <Router>
//       {/* <Header isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} /> */}
//       <Routes>

//         <Route path="/" element={<Home />} />

//         {/* Login Route */}
//         <Route
//           path="/login"
//           element={
//             userRole
//               ? <Navigate to={`/${userRole}`} replace />
//               : <Login />
//           }
//         />

//         <Route path="/register" element={<Register />} />
//         <Route path="/forgot-password" element={<ForgotPassword />} />
//         <Route path="/reset-password" element={<ResetPassword />} />

//         {/* Admin Route */}
//         <Route
//           path="/admin"
//           element={
//             <ProtectedRoute role="admin">
//               <Admin />
//             </ProtectedRoute>
//           }
//         />

//         {/* User Route */}
//         <Route
//           path="/user"
//           element={
//             <ProtectedRoute role="user">
//               <User />
//             </ProtectedRoute>
//           }
//         />

//       </Routes>
//     </Router>
//   );
// }

// export default App;


import './App.css';
import Home from './pages/Home';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Login from "./pages/Login";
import Admin from "./pages/AdminDashboard";
import User from "./pages/UserDashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Payment from "./pages/Payment";
import PlansPage from "./pages/PlansPage";
import TermsAndConditions from "./pages/TermsAndConditions";
import AboutUs from "./pages/AboutUs";

function AppWrapper() {

  const navigate = useNavigate();
  const userRole = sessionStorage.getItem("role");

  // useEffect(() => {

  //   const checkAutoLogout = () => {

  //     const loginTime = sessionStorage.getItem("loginTime");

  //     if (!loginTime) return;

  //     const currentTime = Date.now();
  //     const diff = currentTime - parseInt(loginTime);

  //     const oneHour = 60 * 60 * 1000; // 1 hour

  //     if (diff > oneHour) {
  //       sessionStorage.clear();
  //       navigate("/login", { replace: true });
  //     }
  //   };

  //   checkAutoLogout();

  //   const interval = setInterval(checkAutoLogout, 60000); // check every 1 min

  //   return () => clearInterval(interval);

  // }, [navigate]);

  useEffect(() => {

    const sessionDuration = 30 * 60 * 1000; // 30 mins

    const checkAutoLogout = () => {
      const loginTime = sessionStorage.getItem("loginTime");
      if (!loginTime) return;

      const diff = Date.now() - parseInt(loginTime);

      if (diff > sessionDuration) {
        sessionStorage.clear();
        navigate("/login", { replace: true });
      }
    };

    checkAutoLogout();
    const interval = setInterval(checkAutoLogout, 60000);

    return () => clearInterval(interval);

  }, [navigate]);


  return (
    <Routes>

      <Route path="/" element={<Home />} />

      <Route
        path="/login"
        element={
          userRole
            ? <Navigate to={`/${userRole}`} replace />
            : <Login />
        }
      />

      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      <Route
        path="/admin"
        element={
          <ProtectedRoute role="admin">
            <Admin />
          </ProtectedRoute>
        }
      />

      <Route
        path="/user"
        element={
          <ProtectedRoute role="user">
            <User />
          </ProtectedRoute>
        }
      />
      <Route path="/payment" element={<Payment />} />
      <Route path="/plans" element={<PlansPage />} />
      <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
      <Route path="/about" element={<AboutUs />} />

    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}

export default App;

